import { useTranslation } from 'react-i18next'
import { useStyletron } from 'baseui'
import { ChevronLeft, ChevronRight } from 'baseui/icon'

const useSidebarMenuToggle = (expanded: boolean) => {
  const { t } = useTranslation()
  const [, theme] = useStyletron()

  return {
    Icon: expanded ? ChevronLeft : ChevronRight,
    iconColor: theme.colors.primary,
    label: t(expanded ? 'menu:collapseMenu' : 'menu:expandMenu'),
  }
}

export default useSidebarMenuToggle
